import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SupplierViewModel } from '@app/_models/_viewModels/supplier.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { SupplierService } from '@app/_services/supplier.service';

import { SupplierEditorComponent } from '@app/suppliers/supplier-editor/supplier-editor.component';

@Component({
  selector: 'app-supplier-editor-drawer',
  templateUrl: './supplier-editor-drawer.component.html',
  styleUrls: ['./supplier-editor-drawer.component.css']
})
export class SupplierEditorDrawerComponent implements OnInit {

  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() supplierViewModel: SupplierViewModel;
  @Input() isEditing: boolean;
  @Output() drawerClosed = new EventEmitter<boolean>();

  @ViewChild(SupplierEditorComponent, { static: false })
  private supplierEditorComponent: SupplierEditorComponent;

  public createForm: NgForm;

  drawerWidth: string;

  isSavingSupplier: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  constructor(
    private supplierService: SupplierService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe(size => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
  }

  closeDrawer(supplierId?: number) {
    this.supplierEditorComponent.resetForm();
    this.drawerClosed.emit(supplierId != null);
  }

}
